export const ZENDESK_SUBMIT_BUG_LINK =
  'https://teamexos.zendesk.com/hc/en-us/requests/new?ticket_form_id=10581449609748';
